export const AboutDogModal = {
  CloseBtn: 'close-btn',
};
